export { default } from './MultiCamPaywall';
